import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mt-4" }
const _hoisted_2 = { class: "h3 my-5" }
const _hoisted_3 = { class: "table table-striped" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  width: "10"
}, "#", -1)
const _hoisted_5 = {
  scope: "col",
  width: "400"
}
const _hoisted_6 = {
  scope: "col",
  width: "100"
}
const _hoisted_7 = ["onClick"]

import { ref } from "vue";
import { translation } from "../../lang/Translation";
import { ClassMembers } from "../../../server/dto/generated/ClassMembers";
import { ClassRoomService } from "../../biz/remote/ClassRoomService";
import { AuthService } from "../../biz/remote/AuthService";
import { MessageDialog } from "../../../framework/frontend/MessageDialog";
import { SessionUser } from "../../utils/SessionUser";
import router from "../../router/index";
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClassMemberListPage',
  setup(__props) {

const t = translation;
const memberList = ref();

const route = useRoute();
const params = new URLSearchParams(location.search);
const teacher_id = route.params.teacher_id as string; //params.get("teacher_id") ? parseInt(params.get("teacher_id")) : 0;
console.log(teacher_id);
if(Number.isNaN(teacher_id)){
  throw new Error("TeacherIDが正しくありません:" + teacher_id)
}
const class_name = route.params.class_name
const biz = new ClassRoomService();
biz.getMembers(Number.parseInt(teacher_id)).then((response) => {
  const list = response.data;
  memberList.value = list.filter((q)=>{ return q.className === class_name})
});

const select = async (member: ClassMembers) => {
  console.log("test");
  const biz = new AuthService();
  const response = await biz.classRoomLogin(member.user_id, member.member_id);
  if (response.hasError) {
    sessionStorage.clear();
    MessageDialog.alert(response.errorDescription);
  } else {
    SessionUser.saveAuthUserInSession(response.data);
    router.push({ name: "ClassMemberContainsListPage" });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t).to("クラスルームにログインします。自分に割り当てられた名前を選択してください。","class_room_description")), 1),
    _createElementVNode("table", _hoisted_3, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _hoisted_4,
          _createElementVNode("th", _hoisted_5, _toDisplayString(_unref(t).to("名前", "name")), 1),
          _createElementVNode("th", _hoisted_6, _toDisplayString(_unref(t).to("選択", "select")), 1)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(memberList.value, (member, index) => {
          return (_openBlock(), _createElementBlock("tr", { key: index }, [
            _createElementVNode("td", null, _toDisplayString(member.member_id), 1),
            _createElementVNode("td", null, _toDisplayString(member.name), 1),
            _createElementVNode("td", null, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: ($event: any) => (select(member))
              }, _toDisplayString(_unref(t).to("選択", "select")), 9, _hoisted_7)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})